import { LOCALE_IT } from '~/constants/localization/locales';

export const useBaseFetch = (path, options = {}) => {
  const { $i18n, $config } = useNuxtApp();
  const baseUrl = $i18n.locale.value === LOCALE_IT ? $config.public.baseDomainIt : $config.public.baseDomainFr;

  let url = `http://${baseUrl}${path}`;

  if (import.meta.client) {
    url = `https://${baseUrl}${path}`;
  }

  return $fetch(url, options)
}
